import React, {useCallback, useEffect, useState} from 'react';
import {useParams, Link} from 'react-router-dom';

import {Breadcrumb, Tabs} from 'antd';

import img1 from '../../../assets/imgs/ask-detail-img1.png';

import {get} from '../../../api';

import './index.scss';

const TabsChildren = ({type}) => {
    return (
        <div className="tabsChildren flex">
            <div className="left-box">
                <img className="h-[300px]" src={img1} alt="img" />
            </div>
            <div className="ml-[2vw] right-box">
                <ul className="list text-[18px] text-[#666]">
                    <li>
                        <a
                            href="."
                            target="_blank"
                            title="我们的秘密真的安全吗？"
                        >
                            · 我们的秘密真的安全吗？
                        </a>
                    </li>
                    <li>
                        <a
                            href="."
                            target="_blank"
                            title="再喜欢也不要在一起的六种男生"
                        >
                            · 再喜欢也不要在一起的六种男生
                        </a>
                    </li>
                </ul>
            </div>
        </div>
    );
};

export default function AskDetail() {
    const {id} = useParams(); // 获取路由参数
    const [detailData, setDetailData] = useState({detail: {}});

    const getDetailData = useCallback(() => {
        get('/getDetail', {id}).then(res => {
            if (res.code === 200) {
                setDetailData(res.data);
                console.log(res.data);
            }
        });
    }, [id]);

    useEffect(() => {
        getDetailData();
    }, [getDetailData]);

    const items = [
        {
            key: '1',
            label: '社交',
            children: <TabsChildren type={1} />,
        },
        {
            key: '2',
            label: '两性',
            children: <TabsChildren type={1} />,
        },
        {
            key: '3',
            label: '娱乐',
            children: <TabsChildren type={1} />,
        },
        {
            key: '4',
            label: '约会',
            children: <TabsChildren type={1} />,
        },
        {
            key: '5',
            label: '私聊',
            children: <TabsChildren type={1} />,
        },
    ];

    return (
        <div id="ask-detail-pc" className="py-[2vw]">
            <Breadcrumb
                className="text-[18px] ml-[8.4vw] mb-[2vw]"
                separator=">"
                items={[
                    {
                        title: <Link className='leading-[20px]' to="/home">首页</Link>,
                    },
                    {
                        title: <Link className='leading-[20px]' to="/ask">资讯中心</Link>,
                    },
                    {
                        title: (
                            <p className="w-[45vw] truncate">
                                {detailData.detail.title}
                            </p>
                        ),
                    },
                ]}
            />

            <div className="px-[4vw] py-[2vw] bg-[#fafafa] w-full flex justify-between">
                <div className="left-box flex-1 mr-[1.5vw]">
                    <div className="title w-full pb-[2vw] text-center border-b">
                        <h1 className="text-[32px] text-[#56585b] font-bold">
                            {detailData.detail.title}
                        </h1>
                        <div className="text-[12px] text-[#929292] mt-[1vw]">
                            <span>
                                发布时间：{detailData.detail.create_time}
                            </span>
                        </div>
                    </div>

                    <div className="content py-[2vw]">
                        <p className="p-[1vw] bg-[#fff] text-[18px] text-[#999999]">
                            {detailData.detail.descrition}
                        </p>

                        <div
                            className="flex flex-col items-center"
                            dangerouslySetInnerHTML={{
                                __html: detailData.detail.content,
                            }}
                        ></div>

                        {/* <div className="text-[14px] text-[#56585b] w-full flex pb-[2vw] border-b">
                            <span className="flex-1">标签：</span>
                            <span className="flex-1">分享到：0</span>
                        </div> */}

                        <div className="pt-[2vw] text-[14px] text-[#56585b] w-full flex">
                            <span className="flex-1">
                                上一篇：
                                <Link
                                    to={`/ask/${detailData.prev?.id}`}
                                    className="flex-1 text-[#006cfb]"
                                >
                                    {detailData.prev?.title}
                                </Link>
                            </span>
                            <span className="flex-1">
                                下一篇：
                                <Link
                                    to={`/ask/${detailData.next?.id}`}
                                    className="flex-1 text-[#006cfb] "
                                >
                                    {detailData.next?.title}
                                </Link>
                            </span>
                        </div>

                        {/* <div className="pt-[2vw]">
                            <Tabs defaultActiveKey="1" items={items} />
                        </div> */}
                    </div>
                </div>

                {/* <div className="right-box">
                    <div className="text-[18px]">
                        <h1 className="text-[#006cff] font-bold">推荐阅读</h1>

                        <ul className="text-[18px] text-[#666]">
                            <li>
                                <Link to="">
                                    · 和女朋友谈恋爱时会聊私密的事…
                                </Link>
                            </li>
                            <li>
                                <Link to="">
                                    · 和女朋友谈恋爱时会聊私密的事…
                                </Link>
                            </li>
                            <li>
                                <Link to="">
                                    · 和女朋友谈恋爱时会聊私密的事…
                                </Link>
                            </li>
                        </ul>
                    </div>

                    <div className="text-[18px] mt-[2vw]">
                        <h1 className="text-[#000] font-bold">热点资讯</h1>

                        <ul className="text-[18px] text-[#666]">
                            <li>
                                <Link to="">
                                    · 和女朋友谈恋爱时会聊私密的事…
                                </Link>
                            </li>
                            <li>
                                <Link to="">
                                    · 和女朋友谈恋爱时会聊私密的事…
                                </Link>
                            </li>
                            <li>
                                <Link to="">
                                    · 和女朋友谈恋爱时会聊私密的事…
                                </Link>
                            </li>
                        </ul>
                    </div>
                </div> */}
            </div>
        </div>
    );
}
